jQuery(($) => {

  const snazzyMapsStyles = [
    {
      "featureType": "administrative",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#444444"
          }
      ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f2f2f2"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "saturation": -100
            },
            {
                "lightness": 45
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#46bcec"
            },
            {
                "visibility": "on"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#00b7bd"
            }
        ]
    }
  ];


  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el, $markers = false) {
    // Create generic map.
    var mapArgs = {
      zoom: 8,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: snazzyMapsStyles
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add me
    if (GOOGLEMAP.me['geo_point.location']) {
      map.me = new google.maps.Marker({
        position: {
          lat: parseFloat(GOOGLEMAP.me['geo_point.location'].lat),
          lng: parseFloat(GOOGLEMAP.me['geo_point.location'].lng),
        },
        map: map,
        icon: {
          url: GOOGLEMAP.icons.purple,
          origin: new google.maps.Point(0, 0),
        }
      });
    }

    // Add markers.
    map.markers = [];
    if ($markers) {
      $markers.each(function () {
        initMarker($(this), map);
      });
    }

    setTimeout(() => {
      const icon = window.btoa(`
      <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
        <g id="map-cluster" transform="translate(4754 184)">
          <circle id="bottom-circle" cx="64" cy="64" r="64" transform="translate(-4754 -184)" fill="rgba(59, 76, 88,0.3)"/>
          <circle id="mid-circle" cx="54" cy="54" r="54" transform="translate(-4744 -174)" fill="rgba(59, 76, 88,0.4)"/>
          <circle id="top-circle" cx="44" cy="44" r="44" transform="translate(-4734 -164)" fill="#3B4C58"/>
        </g>
      </svg>
      `);

      new markerClusterer.MarkerClusterer({ 
        markers: map.markers, 
        map,
        renderer: {
          render: ({ count, position }) =>
            new google.maps.Marker({
              label: { text: String(count), color: "#ffffff", fontSize: "16px" },
              position,
              // adjust zIndex to be above other markers
              zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
              icon: {
                url: `data:image/svg+xml;base64,${icon}`,
                scaledSize: new google.maps.Size(45, 45),
              }
            }),
        }
      });
    }, 100);

    // Center map based on markers.

    const defaultSelected = map.markers.filter(marker => marker.defaultSelected);
    if (defaultSelected.length) {
      centerMap(map, defaultSelected);
      if (defaultSelected[0]?.element?.click) {
        defaultSelected[0].element.click();
      }
    } else {
      centerMap(map);
    }


    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    
    if (!lat || !lng) return;
    
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    const infoWindow = new google.maps.InfoWindow({
      content: $marker[0].outerHTML
    });

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: GOOGLEMAP.icons.blue,
        origin: new google.maps.Point(0, 0),
      },
      title: $marker.find('h3')?.text(),
      element: $marker,
      infoWindow,
      defaultSelected: $marker.hasClass('js-map-marker--default-selected')
    });

    // Append to reference for later use.
    map.markers.push(marker);    

    function handleMarkerClick() {
      map.markers.forEach(function (marker) {
        marker.element.removeClass('js-map-marker--active');
        marker.infoWindow?.close();
        marker.setIcon({
          url: GOOGLEMAP.icons.blue,
          origin: new google.maps.Point(0, 0),
        });
      });

      $marker.addClass('js-map-marker--active');

      // We only want autoPan to be enabled when the infoWindow is opened.
      // Why? Because its behavior conflicts with the markerClusterer.
      // If an infoWindow is open but a cluster is clicked elsewhere,
      // It would cause the map to zoom in on the infoWindow, not the cluster
      // See https://stackoverflow.com/a/77956916      
      marker.infoWindow.setOptions({ disableAutoPan: false });
      marker.infoWindow.open({
        anchor: marker,
        map
      })
      marker.infoWindow.setOptions({ disableAutoPan: true });

      // Make js-map fire a custom event when marker is clicked
      const event = new CustomEvent('marker-click', {
        detail: {
          marker: marker.element,
          infoWindow: marker.infoWindow
        }
      });
      $('.js-map')[0].dispatchEvent(event);
    }

    function handleMarkerMouseover() {
      $marker.addClass('js-map-marker--hover');
    }

    function handleMarkerMouseout() {
      marker.element.removeClass('js-map-marker--hover');
    }

    // Handle events on marker
    google.maps.event.addListener(marker, 'click', handleMarkerClick);
    google.maps.event.addListener(marker, 'mouseover', handleMarkerMouseover);
    google.maps.event.addListener(marker, 'mouseout', handleMarkerMouseout);

    // Handle events on feed items
    $marker.on('click', handleMarkerClick);
    $marker.on('mouseover', handleMarkerMouseover);
    $marker.on('mouseout', handleMarkerMouseout);
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map, markers) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();

    if (!markers) {
      markers = map.markers;
    }

    markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    let ne = bounds.getNorthEast();
    let sw = bounds.getSouthWest();
    let lat = ne.lat();
    let diff = lat - sw.lat();
    let newlat = lat + (136 * diff) / $('.js-map').height();

    bounds.extend({
      lat: newlat,
      lng: ne.lng(),
    });

    // if no markers
    if (markers.length == 0) {
      if (map.me) {
        map.setCenter(map.me.getPosition());
      } else {
        map.setCenter({
          lat: 41.8778164,
          lng: -87.631246,
        });
        map.setZoom(4);
      }
      // Case: Single marker.
    } else if (markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(10);
      // Case: Multiple markers.
    } else {
      if (map.me) {
        bounds.extend({
          lat: map.me.position.lat(),
          lng: map.me.position.lng(),
        });
      }

      map.fitBounds(bounds);
    }
  }

  function closeAllInfoWindows(map) {
    map.markers.forEach(marker => {
      marker.element.removeClass('js-map-marker--active');
      marker.infoWindow?.close();
      marker.setIcon({
        url: GOOGLEMAP.icons.blue,
        origin: new google.maps.Point(0, 0),
      });
    });
  }

  // Render maps on page load.
  $(document).ready(function () {
    if ($('.js-map').length === 0) return;
    let map = initMap($('.js-map'), $('.js-map-marker'));

    $('.js-map-center-button').on('click', function () {
      closeAllInfoWindows(map);
      centerMap(map);
    });
  });

});
